export { EventCard as default } from './EventCard';
